import Link from 'next/link'
import Image from 'next/image'
import { AlertTriangle } from 'lucide-react'

interface ICreditAlertProps {
  creditsPerToken?: number
  showLink?: boolean
  poweredByLogo?: string
  tokenUnit?: string
  showPoweredBy?: boolean
  showAlert?: boolean
}

export function CreditAlert(props: ICreditAlertProps) {
  const {
    showPoweredBy = false,
    poweredByLogo,

    showAlert = true,
    creditsPerToken = 3,
    tokenUnit = '1k',
    showLink = true,
  } = props

  const shouldShowPoweredBy = showPoweredBy
  const shouldShowAlert = showAlert && typeof creditsPerToken === 'number'

  if (!shouldShowPoweredBy && !shouldShowAlert) {
    return null
  }

  const containerClasses =
    shouldShowPoweredBy && shouldShowAlert ? 'rounded-lg overflow-hidden' : ''

  const poweredByClasses = `flex items-center justify-between gap-2 text-xs text-gray-500 w-full py-6 px-5 bg-white/10 ${
    !shouldShowAlert ? 'rounded-lg' : ''
  }`

  const alertClasses = `flex items-center gap-2 bg-[#FFF9E7] p-4 text-sm text-[#B99F3B] ${
    !shouldShowPoweredBy ? 'rounded-lg' : ''
  }`

  const validPoweredByLogo = poweredByLogo?.startsWith('http')

  return (
    <div className={`flex flex-col ${containerClasses}`}>
      {shouldShowPoweredBy && (
        <div className={poweredByClasses}>
          <span className="text-white/60 text-sm">Powered by</span>
          {validPoweredByLogo && (
            <Image
              src={poweredByLogo!}
              alt="Powered by"
              width={32}
              height={32}
              className="rounded-sm"
            />
          )}
        </div>
      )}
      {shouldShowAlert && (
        <div className={alertClasses}>
          <AlertTriangle className="h-5 w-5" />
          <div className="flex flex-wrap items-center gap-1">
            <span className="font-medium">
              {creditsPerToken} credits per {tokenUnit} tokens.
            </span>
            <span>Visitors will use your credits too.</span>
            {showLink && (
              <Link
                href="/usage-history"
                className="underline hover:text-[#8B7424]"
              >
                View Credit Usage History
              </Link>
            )}
          </div>
        </div>
      )}
    </div>
  )
}
